export function makeId(candidate = "") {
    if (typeof candidate === "string") {
        if (candidate.length < 2) return candidate
        const output = candidate.camelize().replace(/\W+/g, "")
        return output[0].toLowerCase() + output.slice(1)
    }
    return candidate
}
